import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PublicPage, PageHero, Seo } from "@/components/public/PublicChrome";

const TAG = { feature: "bg-[#D4AF37]/15 text-[#D4AF37]", fix: "bg-blue-500/15 text-blue-300", improvement: "bg-emerald-500/15 text-emerald-300" };

export default function Changelog() {
  const [entries, setEntries] = useState([]);
  useEffect(() => { api.get("/changelog").then((r) => setEntries(r.data.entries)).catch(() => {}); }, []);

  return (
    <PublicPage>
      <Seo title="Changelog" description="What's new in Fairview Systems." path="/changelog" />
      <PageHero eyebrow="Trust Center" title="Changelog" subtitle="Everything we've shipped, in reverse order." />
      <div className="max-w-3xl mx-auto px-6 pb-24 space-y-4" data-testid="changelog-list">
        {entries.map((e) => (
          <div key={e.id} className="rounded-2xl border border-white/8 bg-[#121214] p-6" data-testid="changelog-entry">
            <div className="flex items-center gap-3 mb-2">
              <span className="font-heading text-lg text-white">v{e.version}</span>
              <span className={`text-[10px] px-2 py-0.5 rounded-full capitalize ${TAG[e.tag] || TAG.feature}`}>{e.tag}</span>
              <span className="text-xs text-[#52525B] ml-auto">{e.date}</span>
            </div>
            <div className="text-[#D4AF37] font-medium text-sm mb-2">{e.title}</div>
            <ul className="space-y-1.5">
              {e.items.map((it, i) => <li key={i} className="text-sm text-[#D4D4D8] flex gap-2"><span className="text-[#D4AF37]">•</span>{it}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </PublicPage>
  );
}
